import { Component, OnDestroy, OnInit } from "@angular/core";
import { Message } from "primeng/primeng";
import { Subscription } from "rxjs/Rx";
import { NgxTranslateService } from "../shared/ngx-translate.service";

import { NotificationSettingService } from "./notification-settings.service";
import {
  MessagePreference,
  UserMessagePreference,
  ProviderType,
  MessageTypeGrouping
} from "./model";
import { WhiteLabelService } from "../white-label/white-label.service";
import { WhiteLabelSettings } from "../white-label/white-label.model";

@Component({
  moduleId: module.id.toString(),
  template: require('./notification-settings.component.html')
})
export class NotificationSettingsComponent implements OnInit, OnDestroy {
  constructor(private msgPrefsService: NotificationSettingService, private translateService: NgxTranslateService, private whiteLabelService: WhiteLabelService) { }
  userPref: UserMessagePreference;
  headers: string[];
  busy: Subscription;
  disableSave: boolean = true;
  messages: Message[] = [];
  originalUserPref: UserMessagePreference;
  whiteLabelSettings: WhiteLabelSettings;
  whiteLabelSubscription: Subscription;

  ngOnInit(): void {
    this.whiteLabelSettings = this.whiteLabelService.whiteLabelData;
    this.whiteLabelSubscription = this.whiteLabelService.whiteLabelDataSubject.subscribe(
      whitelabel => {
        this.whiteLabelSettings = whitelabel;
        this.userPref = this.whiteLabelPreferencesFormat(this.userPref);

        let msgPref = this.userPref.messageTypeGroupings[0];
        this.headers = this.prepareHeaders(msgPref);
      }
    );
    this.getPreferencesData();
  }

  ngOnDestroy(): void {
    if (this.whiteLabelSubscription)
      this.whiteLabelSubscription.unsubscribe();
  }

  getPreferencesData() {
    this.disableSave = true;
    this.busy = this.msgPrefsService.getMessagingPrefs().subscribe(
      userPref => {
        this.userPref = this.whiteLabelPreferencesFormat(userPref);

        if (
          this.userPref &&
          this.userPref.messageTypeGroupings &&
          this.userPref.messageTypeGroupings.length
        ) {
          let msgPref = this.userPref.messageTypeGroupings[0];
          this.headers = this.prepareHeaders(msgPref);

          this.disableSave = false;
          this.originalUserPref = this.deepCopyUserPreference(userPref);
        }
      },
      error => {
        console.log(error);
        // this.messages.push({
        //     severity: 'error',
        //     detail: 'There was a problem retrieving your notification preferences.',
        //     summary: 'Error!'
        // });
        this.disableSave = true;
      }
    );
  }

  prepareHeaders(typeGroupings: MessageTypeGrouping) {
    let filteredHeaders = typeGroupings.messagePreferences[0].providerTypes.filter(f => f.visible === true).map(
      function (type) {
        return type.name;
      }
    );

    return filteredHeaders;
  }

  whiteLabelPreferencesFormat(userPreferences: UserMessagePreference): UserMessagePreference {
    let isWhiteLabel = this.whiteLabelSettings && this.whiteLabelSettings.isWhiteLabel;

    userPreferences.messageTypeGroupings.forEach(group => {

      if (group.category === 'Scheduling') {
        let isVisible = true;

        if (isWhiteLabel)
          if ((this.whiteLabelSettings.configurations['ConfigureNotifications'] === true) && (this.whiteLabelSettings.configurations['SuppressNotification'] === true))
            isVisible = false;

        group.visible = isVisible;
      }
      else {
        group.visible = true;
      }

      group.messagePreferences.forEach(groupItem => {
        groupItem.providerTypes.forEach(type => {
          if (type.name === 'Mobile')
            type.visible = !isWhiteLabel;
          else
            type.visible = true;
        })
      })
    });

    return userPreferences;
  }

  onSave(): void {
    this.busy = this.msgPrefsService
      .saveMessagingPrefs(this.userPref)
      .subscribe(
        pref => {
          this.messages.push({
            severity: "info",
            detail: this.translateService.getText('Notification_Save_Message', "Notification preferences saved."),
            summary: this.translateService.getText('Notification_Success', "Success!")
          });
          this.originalUserPref = this.deepCopyUserPreference(this.userPref);
        },
        error => {
          console.log(error);
          this.messages.push({
            severity: "error",
            detail: this.translateService.getText('Notification_Error_Message', "There was a problem saving your notification preferences."),
            summary: this.translateService.getText('Notification_Error', "Error!")
          });
        }
      );
  }

  buttonState(): boolean {
    return this.disableSave;
  }

  onCancel(): void {
    this.userPref = this.whiteLabelPreferencesFormat(this.deepCopyUserPreference(this.originalUserPref));
  }

  deepCopyUserPreference(
    userPreference: UserMessagePreference
  ): UserMessagePreference {
    return JSON.parse(JSON.stringify(userPreference));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/notification/notification-settings.component.ts